import { useEffect } from 'react';
import { Empty, Typography, Table, Tag } from 'antd';
import { useSingleService } from './SingleServiceStore';

const { Text } = Typography;

const workStatusMap = {
    active: { color: 'green', label: 'Faol' },
    fired: { color: 'red', label: "Bo'shatilgan" },
    on_leave: { color: 'orange', label: "Ta'tilda" },
};

function ServiceEmployees({ serviceId }) {
    const { employees, getEmployees } = useSingleService();

    useEffect(() => {
        if (serviceId) getEmployees(serviceId);
    }, [serviceId, getEmployees]);

    const columns = [
        { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
        {
            title: 'Rasm', dataIndex: 'avatar', key: 'avatar', width: 60,
            render: (v) => v ? <img src={process.env.REACT_APP_URL + v} alt="" style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }} /> : '—',
        },
        { title: 'Ism familya', dataIndex: 'fullname', key: 'fullname' },
        { title: 'Telefon', dataIndex: 'phone', key: 'phone' },
        { title: 'JSHSHIR', dataIndex: 'jshshir', key: 'jshshir' },
        {
            title: 'Lavozim', dataIndex: 'position_name', key: 'position_name',
            render: (v) => v ? <Tag color="blue">{v}</Tag> : '—',
        },
        {
            title: 'Maosh', dataIndex: 'salary', key: 'salary',
            render: (val, rec) => val ? `${Number(val).toLocaleString()} so'm${rec.salary_type ? ' / ' + rec.salary_type : ''}` : '—',
        },
        {
            title: 'Holati', dataIndex: 'work_status', key: 'work_status',
            render: (status) => {
                const s = workStatusMap[status] || { color: 'default', label: status || '—' };
                return <Tag color={s.color}>{s.label}</Tag>;
            },
        },
        { title: 'Yaratilgan', dataIndex: 'created', key: 'created', render: (v) => v ? String(v).slice(0, 10) : '—' },
    ];

    return (
        <div style={{ padding: '16px 0' }}>
            <div style={{ marginBottom: 16 }}>
                <Text strong style={{ fontSize: 16 }}>Xodimlar ({employees.length})</Text>
            </div>
            <Table
                dataSource={employees}
                columns={columns}
                rowKey="id"
                size="small"
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Xodimlar yo'q" /> }}
            />
        </div>
    );
}

export default ServiceEmployees;
